import { render, staticRenderFns } from "./newBroker1.vue?vue&type=template&id=6791d458&"
import script from "./newBroker1.vue?vue&type=script&lang=js&"
export * from "./newBroker1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports